import { AnimatePresence, motion } from 'framer-motion';

import { Icon } from '@/new/components/icon';

const blurTransition = { duration: 0.1 };
const blurInitial = { opacity: 0, filter: 'blur(2px)' };
const blurAnimate = { opacity: 1, filter: 'blur(0px)' };
const blurExit = { opacity: 0, filter: 'blur(2px)' };

export function CompactingMessage({ isComplete }: { isComplete: boolean }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2 }}
      className="mx-auto my-4 flex max-w-3xl items-center gap-2 rounded-lg border border-gray-300 bg-gray-100 px-3 py-2 text-xs text-gray-600"
    >
      <AnimatePresence mode="wait">
        {isComplete ? (
          <motion.span
            key="complete"
            className="flex items-center gap-2"
            initial={blurInitial}
            animate={blurAnimate}
            exit={blurExit}
            transition={blurTransition}
          >
            <Icon className="lucide--check text-sm text-gray-400" />
            <span>Compacted message history</span>
          </motion.span>
        ) : (
          <motion.span
            key="in-progress"
            className="flex items-center gap-2"
            initial={blurInitial}
            animate={blurAnimate}
            exit={blurExit}
            transition={blurTransition}
          >
            <Icon className="lucide--loader animate-spin text-sm text-gray-400 ease-in-out" />
            <span>Compacting message history. This might take a few minutes...</span>
          </motion.span>
        )}
      </AnimatePresence>
    </motion.div>
  );
}
